import { render, staticRenderFns } from "./DocumentPreviewDialog.vue?vue&type=template&id=6f6cdddc&scoped=true"
import script from "./DocumentPreviewDialog.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewDialog.vue?vue&type=style&index=0&id=6f6cdddc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6cdddc",
  null
  
)

export default component.exports